var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef } from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import { push } from 'connected-react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import ReactPixel from 'react-facebook-pixel';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MODALS, openModal } from '~modals';
import { setActiveGame, setTournamentParams, useActiveGameSelector, useIsEasyTipSelector, } from '~slices/games';
import { useGameBalance } from '~api/hooks/useGameBalance';
import { useGames } from '~api/hooks/useGames';
import { useIdsMap } from '~api/hooks/useIdsMap';
import { useJokers } from '~api/hooks/useJokers';
import { AUTH_DATA, CLOSE_SPLASH, REWARDED_FAILED, REWARDED_LOADED, REWARDED_SUCCESS, } from '~constants/cpa-message-codes';
import { useUpdateActiveGameAuto } from '~hooks/useUpdateActiveGameAuto';
import { Footer, Header, RightSide, SportList } from '~mainGrid';
import { changeOnlineStatus, selectApplicationOnlineStatus, } from '~slices/application';
import { deleteFullBetslip } from '~slices/betslip';
import { BETSLIP_SOCKET_NAME } from '~slices/events';
import { resetShortcutBetlsip, shortcutCountSelector } from '~slices/shortcut';
import { availableSportsSelector } from '~slices/sports';
import { useAppDispatch } from '~store/configureStore';
import { getCookieAccepatation, isAuthenticatedSelector, isCookieAcceptedSelector, logout, refresh, updateAuthData, useAuthDataSelector, } from '~slices/auth';
import { changeLocalSportId, getLanguage, getOptions, localSportIdSelector, optionsDataSelector, selectHeaderSportId, setSportName, userSportIdSelector, } from '~slices/options';
import { checkTermsHaveUpdate, resetTermsState, termsAcceptStatusSelectorDataSelector, termsHaveUpdatesSelector, } from '~slices/terms';
import { getCashOut } from '~slices/cashOut';
import { getTickets } from '~slices/tickets';
import { getAccount } from '~slices/account';
import { useIsDesktop, usePlatofrmType, useStructuredSelector, useWindowResize, } from '~hooks';
import { CookieConsent } from '~organisms';
import { ratio } from '~theme';
import { PLATFORMS } from '~slices/teasers';
import { contentContainerSizeAtom } from '~utils/atoms/globalAtoms';
import { compareVersions } from '~utils/compareVersions';
import { pxToNumber } from '~utils/css';
import { addExternalScript } from '~utils/addExternalScript';
import { getPathWithLanguageCode } from '~utils/languageInURL/getPathWithLanguageCode';
import { GERMAN, checkIfIsLanguageInURL, languagesList, } from '~utils/languageInURL';
import { getUserCountryLanguage } from '~slices/userCountryLanguage';
import { isBetCheckProject } from '~utils/constants/betCheckConstants';
import { getPlayerAccounts, setPlayerAccounts, setRewardedLoadedStatus, } from '~slices/playerAccounts';
import { loadCpaAppVersionFromStorage } from '~utils/localStorage';
import { postLogoutPressMessage } from '~utils/postLogoutPressMessage';
import { IS_DEV } from '~/config/env';
var prevRatio = NaN;
var memoizedZoom = function () {
    if (prevRatio) {
        return String(1 / prevRatio);
    }
    prevRatio = ratio();
    return String(1 / prevRatio);
};
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c;
    return (_a = {
            '@global': {
                body: {
                    '& > *': {
                        zoom: memoizedZoom(),
                    },
                    '& > div[style*="visibility"]': {
                        zoom: '1',
                    },
                    '& > div > div[style*="z-index: 2000000000"]:nth-child(2)': {
                        transform: "scale(".concat(memoizedZoom(), ") translate(-50%, -50%) !important"),
                    },
                },
                iframe: {
                    height: "calc(".concat(100 * ratio(), "vh - 50px)"),
                },
            }
        },
        _a["@media (min-width: ".concat(1366 / ratio(), "px)")] = {
            '@global': {
                iframe: {
                    height: "calc(".concat(100 * ratio(), "vh - 107px)"),
                },
            },
        },
        _a.flexColumn = {
            display: 'flex',
            flexDirection: 'column',
        },
        _a.mainContainer = {
            overflow: 'auto',
            maxHeight: '100%',
            minHeight: 'calc(100vh - calc(100vh - 100%))',
        },
        _a.main = {
            minHeight: '100vh',
            background: theme.variables.mainBackgroundColor.color,
            overflowX: 'hidden',
        },
        _a.content = {
            flex: 'auto',
            borderRadius: '4px',
            minHeight: '560px',
        },
        _a.testStyles = {
            background: '#151515',
            color: '#8E8E8E',
            display: 'grid',
            fontSize: '42px',
            fontWeight: 'bold',
        },
        _a.sports = (_b = {
                position: 'fixed',
                bottom: '30px',
                left: '30px',
                top: '106px',
                width: '283px',
                background: '#151515',
                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.05)',
                borderRadius: '4px',
                fontSize: '18px',
                lineHeight: '18px',
                color: '#8E8E8E',
                boxSizing: 'border-box',
                padding: '16px',
                display: 'grid'
            },
            _b[theme.breakpoints.up('lg')] = {
                boxSizing: 'border-box',
                position: 'static',
                flex: '0 0 283px',
                marginRight: 30,
                overflow: 'auto',
            },
            _b),
        _a.contentContainer = (_c = {
                paddingTop: '52px',
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                minHeight: 'calc(100vh - calc(100vh - 100%) - 52px)'
            },
            _c[theme.breakpoints.up('lg')] = {
                boxSizing: 'border-box',
                height: "".concat(100 * ratio(), "vh"),
                minHeight: 700,
                flexDirection: 'row',
                marginBottom: 30,
                padding: '106px 30px 0',
            },
            _c),
        _a);
}, { name: 'Main' });
export var Main = function (_a) {
    var children = _a.children;
    useUpdateActiveGameAuto();
    var theme = useTheme();
    var classes = useStyles(theme);
    var platform = usePlatofrmType();
    var isDesktop = useIsDesktop();
    var dispatch = useAppDispatch();
    var _b = useStructuredSelector({
        isAuthenticated: isAuthenticatedSelector,
        isEasyTip: useIsEasyTipSelector,
        optionsData: optionsDataSelector,
        termsHaveUpdate: termsHaveUpdatesSelector,
        termsAccetpted: termsAcceptStatusSelectorDataSelector,
        token: useAuthDataSelector,
        cookieAccepted: isCookieAcceptedSelector,
        activeGame: useActiveGameSelector,
        online: selectApplicationOnlineStatus,
        userSportId: userSportIdSelector,
        sportId: selectHeaderSportId,
        localSportId: localSportIdSelector,
        sports: availableSportsSelector,
        shortcutCount: shortcutCountSelector,
    }), isAuthenticated = _b.isAuthenticated, isEasyTip = _b.isEasyTip, wasLoadedOptions = _b.optionsData.wasLoadedOptions, termsHaveUpdate = _b.termsHaveUpdate, termsAccetpted = _b.termsAccetpted, token = _b.token, cookieAccepted = _b.cookieAccepted, activeGame = _b.activeGame, online = _b.online, userSportId = _b.userSportId, sportId = _b.sportId, localSportId = _b.localSportId, sports = _b.sports, shortcutCount = _b.shortcutCount;
    var _c = useTranslation('errors', {
        useSuspense: false,
    }), t = _c.t, isI18nReady = _c.ready;
    var _d = useLocation(), pathname = _d.pathname, search = _d.search;
    var getJokersMetaInfo = useJokers().getJokersMetaInfo;
    var _e = useGames(), getSingleGame = _e.getSingleGame, getGamesMetaInfo = _e.getGamesMetaInfo;
    var getIdsMap = useIdsMap().getIdsMap;
    var postGameBalance = useGameBalance().postGameBalance;
    var params = new URLSearchParams(search);
    var selectedGameParam = params.get('selectedGame');
    var selectedGroupParam = params.get('selectedGroup');
    var groupKeyParam = params.get('groupKey');
    var tournamentParam = params.get('tournament');
    var isCPA = platform === PLATFORMS.CROSS_PLATFORM_MOBILE;
    var isLeagueDaysPage = pathname.includes('/home/') && !pathname.includes('/all/live');
    var isCookieConsent = cookieAccepted !== undefined && !cookieAccepted && !isCPA;
    var initialPath = useRef(null);
    var redirectToTerms = function () {
        var pathname = '/about';
        if (isDesktop) {
            pathname = '/about/info/terms_conditions';
        }
        var route = {
            pathname: pathname,
            state: {
                type: 'info',
                mobileTab: 'terms',
            },
        };
        dispatch(push(getPathWithLanguageCode(route.pathname), route.state));
    };
    var updateGameBalance = function (game) { return __awaiter(void 0, void 0, void 0, function () {
        var gameUrl, gameName, gameUid, groupKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    gameUrl = game.url, gameName = game.name, gameUid = game.gameUid, groupKey = game.groupKey;
                    return [4 /*yield*/, postGameBalance({
                            gameUrl: gameUrl,
                            gameName: gameName,
                            gameUid: gameUid,
                            groupKey: groupKey,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleRNMessage = function (event, game) {
        try {
            if (event.data) {
                var parsedData = JSON.parse(event.data);
                var code = parsedData === null || parsedData === void 0 ? void 0 : parsedData.code;
                var params_1 = parsedData === null || parsedData === void 0 ? void 0 : parsedData.params;
                if (code === REWARDED_SUCCESS || code === REWARDED_FAILED) {
                    updateGameBalance(game);
                    dispatch(getPlayerAccounts()).then(function (_a) {
                        var payload = _a.payload;
                        setPlayerAccounts(payload);
                    });
                }
                if (code === REWARDED_LOADED) {
                    dispatch(setRewardedLoadedStatus(true));
                }
                if (code === AUTH_DATA && params_1) {
                    dispatch(updateAuthData(params_1));
                }
            }
        }
        catch (error) { }
    };
    var setGameNameInURL = function (id) {
        var selectedSport = sports.find(function (game) { return game.id === id; });
        var name = (selectedSport === null || selectedSport === void 0 ? void 0 : selectedSport.name) || '';
        dispatch(setSportName({ id: id, name: name }));
        dispatch(push({
            pathname: getPathWithLanguageCode("/home/all/live/".concat(name)),
            search: search,
        }));
    };
    var findGameByNameFromURL = useCallback(function () {
        var splitPathname = window.location.pathname.split('/');
        var possiblySport = splitPathname[3];
        var lastURLPart = splitPathname[splitPathname.length - 1];
        return sports.find(function (game) {
            return (game === null || game === void 0 ? void 0 : game.name) === decodeURI(possiblySport) ||
                (game === null || game === void 0 ? void 0 : game.name) === decodeURI(lastURLPart);
        });
    }, [sports]);
    var dispatchLocalSportId = function (id) {
        dispatch(changeLocalSportId({
            id: id,
            desktop: isDesktop,
            langIso: i18next.language,
        }));
    };
    var changeSport = function (id) {
        setGameNameInURL(id);
        if (localSportId !== id) {
            dispatchLocalSportId(id);
        }
    };
    useEffect(function () {
        var selectedGameFromURL = findGameByNameFromURL();
        if (selectedGameFromURL && selectedGameFromURL.id !== localSportId) {
            dispatchLocalSportId(selectedGameFromURL.id);
        }
    }, []);
    useEffect(function () {
        getJokersMetaInfo();
    }, []);
    useEffect(function () {
        if (pathname.endsWith('home/all/live') ||
            pathname.endsWith('home/all/live/')) {
            if (sportId) {
                changeSport(sportId);
            }
            if (!sportId && !isAuthenticated && sports) {
                var firstSport = sports[0];
                changeSport((firstSport === null || firstSport === void 0 ? void 0 : firstSport.id) || 1);
            }
            return;
        }
        var selectedGameFromURL = findGameByNameFromURL();
        if (selectedGameFromURL && selectedGameFromURL.id !== localSportId) {
            dispatchLocalSportId(selectedGameFromURL.id);
            return;
        }
    }, [sports, userSportId]);
    useEffect(function () {
        if (!activeGame)
            return;
        window.addEventListener('message', function (e) { return handleRNMessage(e, activeGame); }, false);
        return function () {
            window.removeEventListener('message', function (e) {
                return handleRNMessage(e, activeGame);
            });
        };
    }, [activeGame]);
    useEffect(function () {
        if (IS_DEV)
            return;
        ReactPixel.trackCustom('page view', { page: window.location.pathname });
    }, [window.location.pathname]);
    useEffect(function () {
        if (window.location.pathname === '/' ||
            window.location.pathname === "/".concat(i18next.language, "/")) {
            if (isAuthenticated) {
                dispatch(push(getPathWithLanguageCode(isDesktop ? '/home' : '/ranking-list')));
            }
            else {
                dispatch(push(getPathWithLanguageCode('/start')));
            }
        }
    }, []);
    useEffect(function () {
        var _a;
        if (isCPA) {
            initialPath.current = { pathname: pathname, search: search };
            (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ code: CLOSE_SPLASH }));
        }
    }, []);
    useEffect(function () {
        var currentURL = window.location.pathname;
        var isLanguageInURL = checkIfIsLanguageInURL(currentURL);
        if (!isLanguageInURL) {
            dispatch(getUserCountryLanguage()).then(function (result) {
                var payload = result.payload;
                var userCountryLanguage = payload.languageCode;
                var pushURL = function () {
                    dispatch(push({
                        pathname: getPathWithLanguageCode(currentURL),
                        search: search,
                    }));
                };
                if (languagesList.includes(userCountryLanguage)) {
                    i18next.changeLanguage(userCountryLanguage).then(function () { return pushURL(); });
                }
                else {
                    i18next.changeLanguage(GERMAN).then(function () { return pushURL(); });
                }
            });
        }
    }, [isAuthenticated, i18next.language, window.location.pathname]);
    useEffect(function () {
        if (termsHaveUpdate)
            redirectToTerms();
    }, [isDesktop]);
    useEffect(function () {
        if (!isEasyTip === undefined)
            return;
        if (!isCPA || !isEasyTip)
            void getIdsMap();
    }, [isAuthenticated, isCPA, isEasyTip]);
    useEffect(function () {
        var handleOnline = function () {
            console.log('online');
            dispatch(changeOnlineStatus(true));
            window.location.href = initialPath.current
                ? "".concat(initialPath.current.pathname).concat(initialPath.current.search)
                : window.location.pathname;
        };
        var handleOffline = function () {
            console.log('offline');
            dispatch(changeOnlineStatus(false));
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return function () {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (!document.hidden && window.navigator.onLine !== online) {
                dispatch(changeOnlineStatus(window.navigator.onLine));
            }
        };
        if (typeof document.addEventListener === 'undefined') {
            console.error('This page requires a browser, that supports the Page Visibility API.');
        }
        else {
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
        }
        return function () {
            document.removeEventListener('visibilitychange', handleVisibilityChange, false);
        };
    }, []);
    useEffect(function () {
        if (isAuthenticated) {
            dispatch(checkTermsHaveUpdate());
            if (isBetCheckProject) {
                dispatch(getCashOut());
                dispatch(getTickets({
                    tabId: 'ALL',
                    ticketSearchStatus: 'ALL',
                }));
            }
        }
    }, []);
    var logoutAndNotifyCPA = function () {
        if (isCPA) {
            postLogoutPressMessage();
        }
        else {
            dispatch(logout());
        }
    };
    useEffect(function () {
        if (termsAccetpted) {
            dispatch(refresh())
                .then(function () { return dispatch(getAccount()); })
                .then(function () { return dispatch(push(getPathWithLanguageCode('/home'))); })
                .then(function () { return dispatch(resetTermsState()); });
        }
    }, [termsAccetpted]);
    useEffect(function () {
        if (termsHaveUpdate)
            redirectToTerms();
    }, [termsHaveUpdate]);
    useEffect(function () {
        if (isAuthenticated) {
            dispatch(getAccount()).then(function (_a) {
                var _b;
                var payload = _a.payload;
                //@ts-ignore
                if (((_b = payload === null || payload === void 0 ? void 0 : payload.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    logoutAndNotifyCPA();
                }
                if (!IS_DEV) {
                    var userExternalId = payload === null || payload === void 0 ? void 0 : payload.externalId;
                    var scriptBody = "\n            srtmCommands.push({\n              event: \"track.user.login\",\n              payload: {\n                  action: \"complete\",\n                  userId: \"".concat(userExternalId, "\",\n                  }\n            });\n          ");
                    addExternalScript({ body: scriptBody });
                }
            });
        }
        if (!isCPA)
            dispatch(getCookieAccepatation());
        // TODO check it, probably getOptions will never called if default user sport is soccer
        if (isAuthenticated && !wasLoadedOptions) {
            dispatch(checkTermsHaveUpdate());
            dispatch(getOptions());
            dispatch(getLanguage()).then(function (result) {
                if (!result.payload || typeof result.payload !== 'string') {
                    return;
                }
                i18next.changeLanguage(result.payload);
                try {
                    var language = result.payload === 'uk' ? 'ukr' : result.payload;
                    window.SIR('changeLanguage', language);
                }
                catch (e) {
                    console.error('SIR Error:', e);
                }
            });
            dispatch(getTickets({
                tabId: 'ALL',
                ticketSearchStatus: 'ALL',
            }));
        }
    }, [isAuthenticated]);
    useEffect(function () {
        if (isBetCheckProject && isAuthenticated && !wasLoadedOptions) {
            dispatch(getCashOut());
        }
    }, [isAuthenticated]);
    useEffect(function () {
        if (!activeGame || !isAuthenticated || isLeagueDaysPage)
            return;
        updateGameBalance(activeGame);
    }, [activeGame, isAuthenticated]);
    useEffect(function () {
        if (!activeGame || !isAuthenticated)
            return;
        var interval = setInterval(function () {
            updateGameBalance(activeGame);
        }, 30000);
        return function () {
            clearInterval(interval);
        };
    }, [activeGame, isAuthenticated, token]);
    var getSingleGameWithMetaInfo = function (language, gameName, groupName, groupKey) { return __awaiter(void 0, void 0, void 0, function () {
        var metaInfo, name, singleGame;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getGamesMetaInfo(language, gameName, groupName, groupKey)];
                case 1:
                    metaInfo = _a.sent();
                    if (!metaInfo) {
                        if (isCPA) {
                            dispatch(openModal({
                                modalName: MODALS.ERROR_MODAL,
                                modalProps: {
                                    title: t('error_occurred'),
                                    handleConfirm: postLogoutPressMessage,
                                },
                            }));
                        }
                        return [2 /*return*/, null];
                    }
                    name = gameName || metaInfo.gameName;
                    singleGame = null;
                    if (!!isLeagueDaysPage) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSingleGame(metaInfo.url, name)];
                case 2:
                    singleGame = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, __assign(__assign(__assign(__assign(__assign({}, (singleGame && __assign({}, singleGame))), metaInfo), { name: name }), (groupName && { groupName: groupName })), (groupKey && { groupKey: groupKey }))];
            }
        });
    }); };
    useEffect(function () {
        var gameName = selectedGameParam || undefined;
        var groupName = selectedGroupParam || undefined;
        var groupKey = groupKeyParam || undefined;
        if (!isI18nReady)
            return;
        getSingleGameWithMetaInfo(i18next.language, gameName, groupName, groupKey).then(function (activeGameInfo) {
            if (!activeGameInfo)
                return;
            if (tournamentParam) {
                dispatch(setTournamentParams({ pathname: window.location.pathname }));
                var cpaAppVersion = loadCpaAppVersionFromStorage();
                var allowedCpaAppVersion = '1.1.84';
                var isUpdatedCPAVersion = cpaAppVersion &&
                    compareVersions(cpaAppVersion, allowedCpaAppVersion) > 0;
                // "!isCPA" is kept to support in-browser testing
                if (isUpdatedCPAVersion || !isCPA) {
                    activeGameInfo.tournament = tournamentParam;
                }
            }
            if (groupName) {
                activeGameInfo.groupName = groupName;
            }
            if (groupKey) {
                activeGameInfo.groupKey = groupKey;
            }
            dispatch(setActiveGame(activeGameInfo));
        });
    }, [isI18nReady]);
    useEffect(function () {
        var isQueryParam = groupKeyParam || selectedGroupParam || tournamentParam;
        if (isQueryParam && shortcutCount) {
            dispatch(deleteFullBetslip({ eventsType: BETSLIP_SOCKET_NAME })).then(function () { return dispatch(resetShortcutBetlsip()); });
        }
    }, [shortcutCount]);
    var contentContainerRef = useRef(null);
    useWindowResize(function () {
        if (contentContainerRef.current) {
            var computedStyle = getComputedStyle(contentContainerRef.current);
            var height = pxToNumber(computedStyle.height);
            var paddingTop = pxToNumber(computedStyle.paddingTop);
            var paddingBottom = pxToNumber(computedStyle.paddingBottom);
            var contentHeight = height - paddingTop - paddingBottom;
            if (contentContainerSizeAtom.getValue() !== contentHeight) {
                contentContainerSizeAtom.setValue(contentHeight);
            }
        }
    });
    var lastActiveTimeRef = useRef(new Date().getTime());
    useEffect(function () {
        var handleVisibilityChange = function () {
            if (document.visibilityState === 'visible') {
                var currentTime = new Date().getTime();
                var inactiveDuration = (currentTime - lastActiveTimeRef.current) / 1000;
                var updateTimeInSeconds = 300;
                if (inactiveDuration >= updateTimeInSeconds) {
                    dispatch(getAccount()).then(function (_a) {
                        var _b;
                        var payload = _a.payload;
                        //@ts-ignore
                        if (((_b = payload === null || payload === void 0 ? void 0 : payload.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                            logoutAndNotifyCPA();
                        }
                    });
                }
                lastActiveTimeRef.current = currentTime;
            }
        };
        if (isAuthenticated) {
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }
        return function () {
            return document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [isAuthenticated]);
    return (React.createElement("div", { className: classes.mainContainer },
        React.createElement("div", { className: "".concat(classes.main, " ").concat(classes.flexColumn) },
            React.createElement(Header, null),
            React.createElement("div", { ref: contentContainerRef, className: classes.contentContainer },
                isDesktop ? (React.createElement("div", { className: "".concat(classes.sports, " ").concat(classes.testStyles) },
                    React.createElement(SportList, null))) : null,
                React.createElement("div", { className: classNames(classes.content, classes.flexColumn, {
                        'flex-scroll': isDesktop,
                    }) }, children),
                React.createElement(RightSide, null)),
            isDesktop && React.createElement(Footer, null),
            isCookieConsent && React.createElement(CookieConsent, null))));
};
